import { createFileRoute, notFound } from "@tanstack/react-router";
import { StudyGroupChannelsLayout } from "@/features/study-group-channels/components/StudyGroupChannelsLayout";
import { useStudyGroupYourMembership } from "@/hooks/useStudyGroupYourMembership";

export const Route = createFileRoute("/study-group/$study-group-id/stream/")({
  beforeLoad: ({ params }) => {
    const parsedStudyGroupId = Number(params["study-group-id"]);
    if (!Number.isFinite(parsedStudyGroupId) || parsedStudyGroupId <= 0) {
      throw notFound();
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  const { "study-group-id": studyGroupIdParam } = Route.useParams();

  const parsedStudyGroupId = Number(studyGroupIdParam);
  const studyGroupId =
    Number.isFinite(parsedStudyGroupId) && parsedStudyGroupId > 0
      ? parsedStudyGroupId
      : undefined;
  const { canManageMembers, isLoading } = useStudyGroupYourMembership(
    studyGroupId ?? null,
  );

  if (isLoading) {
    return <div className="p-4">Loading...</div>;
  }

  return (
    <StudyGroupChannelsLayout
      studyGroupId={studyGroupId}
      isUserMode={!canManageMembers}
      canManageMembers={canManageMembers}
      initialSelectedChannelId="home"
      enableRouteSync
    />
  );
}
